var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemudaLogoFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420.55 83.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e4e1dc;}.cls-2{fill:#fff;}.cls-3{fill:none;}.cls-4{fill:#ce372f;}.cls-5{fill:#130c0d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.85,29.08v.09c.63.4,1.37.88,2.11,1.43L155.9,35v.2h-7.39l-8-5.94H128.64v5.94h-5.42V15.77H145c8.19,0,10.33,2.77,10.33,7C155.33,26.28,153.22,28.48,147.85,29.08Zm-19.21-3.83h16.53c3.83,0,4.68-.88,4.68-2.51S149,20.2,145,20.2H128.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.34,27.16v4.08h26.12v3.94H172.92V15.77h31.46v3.94h-26v3.8h24.81v3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.5,22.6h-.06L240,33.7h-.23L227.35,22.6h-.09V35.19h-5.42V15.77h4.54l13.48,12h.06l13.48-12h4.54V35.19H252.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.92,15.77V26.54c0,2.94,4.2,4.62,11.33,4.62s11.33-1.68,11.33-4.62V15.77H308V27.39c0,4-5.51,8.19-16.76,8.19s-16.76-4.17-16.76-8.19V15.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.15,15.77h16.9c7.48,0,11.42.86,13.79,2.37a8.06,8.06,0,0,1,3.83,7.39c0,3.74-1.48,6.05-3.8,7.51-2.57,1.6-6.17,2.14-12.68,2.14h-18Zm5.42,15H343c4.71,0,7.28-.29,8.82-1.06a4.17,4.17,0,0,0,2.37-4.17,4.25,4.25,0,0,0-2.43-4.11c-1.71-.88-4.8-1.23-9.91-1.23H330.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M403.39,31.62H384.61l-3.23,3.57h-6.62v-.26l17.3-19.16h3.88l17.3,19.16v.26h-6.62Zm-15.62-3.51h12.48L397.48,25c-1.66-1.83-3.43-4-3.43-4h-.11s-1.71,2.17-3.37,4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "113.36 3.71 113.36 47.77 116.06 47.77 116.06 3.71 113.36 3.71 113.36 3.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "211.83 3.71 211.83 47.77 214.53 47.77 214.53 3.71 211.83 3.71 211.83 3.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "162.59 3.71 162.59 47.77 165.3 47.77 165.3 3.71 162.59 3.71 162.59 3.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "264.82 3.71 264.82 47.77 267.53 47.77 267.53 3.71 264.82 3.71 264.82 3.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "314.06 3.71 314.06 47.77 316.76 47.77 316.76 3.71 314.06 3.71 314.06 3.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "367.11 3.71 367.11 47.77 369.81 47.77 369.81 3.71 367.11 3.71 367.11 3.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "417.85 3.71 417.85 47.77 420.55 47.77 420.55 3.71 417.85 3.71 417.85 3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.43,68.41a4.16,4.16,0,0,1,3.05,4.07c0,3.31-2.11,5-7.1,5H157.71V60.22h20.48c5.09,0,6.61,2.26,6.61,4.58a3.59,3.59,0,0,1-2.37,3.54ZM179,67.54c1.65,0,3.26-.61,3.26-2.57,0-1.5-1-2.77-4.35-2.77H160.25v5.34Zm-18.72,2v6h18c3.41,0,4.6-1.09,4.6-3s-1.48-3-4.25-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.37,60.22V70.29c0,3.26,4.45,5.44,11.85,5.44s11.85-2.19,11.85-5.44V60.22h2.54V70.49c0,3.89-4.5,7.38-14.4,7.38s-14.4-3.49-14.4-7.38V60.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.09,77.52h-2.54V60.22h2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.55,75.38h21.9v2.14H236V60.22h2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.74,60.22h14.42c6.56,0,9.79.79,11.75,2.06a7.36,7.36,0,0,1,3.33,6.64c0,3.33-1.3,5.39-3.31,6.69-2.21,1.42-5.32,1.91-10.89,1.91H264.74Zm2.54,15.16H280c4.78,0,7.43-.41,9.11-1.4s2.57-2.54,2.57-5.06a5.39,5.39,0,0,0-2.59-5c-1.65-1-4.73-1.55-10-1.55h-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.07,77.52h-2.54V60.22h2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.62,63.17h-.08V77.52H310V60.22h2.09c8,4.83,16,9.56,24.06,14.35h.08V60.22h2.54v17.3h-2.09C328.64,72.73,320.65,68,312.62,63.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.43,63.55A63.45,63.45,0,0,0,360.15,62c-5.7.08-9.11.87-11.06,2.26a5.57,5.57,0,0,0-2.34,4.91,5.41,5.41,0,0,0,2.77,5c2.08,1.09,5.09,1.6,10.63,1.6a45.73,45.73,0,0,0,11.73-1.53V70.09h-17.2v-2h19.74v7.61a50,50,0,0,1-14.27,2.16c-6.38,0-9.92-.71-12.34-2a7.26,7.26,0,0,1-3.66-6.66,7.34,7.34,0,0,1,3.36-6.56c2.24-1.53,6.69-2.75,12.64-2.75a58.07,58.07,0,0,1,13.79,1.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 0 0 83.88 98.47 83.88 98.47 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.9,41.22c7.32,0,9-1.69,9-4.81s-1.69-4.86-9.23-4.86H33.12v9.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "68.53 48.37 47.75 48.82 60.35 60.44 81.87 60.44 68.53 48.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "19.66 60.55 33.12 60.55 33.12 31.55 33.12 22.98 19.66 22.98 19.66 60.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.57,23H33.12v8.47H61.63c7.54,0,9.23,1.86,9.23,4.86s-1.64,4.81-9,4.81H33.12v7.65H52.94L67,48.46C77.3,47.31,81.34,43.1,81.34,36.33,81.34,28.3,77.25,23,61.57,23Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemudaLogoFull);
export default __webpack_public_path__ + "static/media/remuda-logo-full.688dcda8e8475e556d1b72338f8f1302.svg";
export { ForwardRef as ReactComponent };